<template>
  <div class="page">
    <Header :title="title" :showBack="true"></Header>

    <!-- 车辆信息 -->
    <van-cell-group v-if="vehicle">
      <!--
      <van-field
        required
        label="运营业务类型："
        v-model="vehicle.OperateBusinessTypeNameList"
        placeholder="请输入运营业务类型"
        @click="showOperateBusinessTypePicker = true"
        label-align="left"
      />
      -->

      <van-field
        required
        label="车牌号码："
        v-model="vehicle.VehicleNo"
        placeholder="请输入车牌号码"
        label-align="left"
      >
        <!-- <van-button
          slot="button"
          size="small"
          type="primary"
          @click="getConwinVehicleInfo"
          >获取车辆资质</van-button
        > -->
      </van-field>

      <van-field
        required
        label="车牌颜色："
        v-model="vehicle.CodeName"
        placeholder="请输入车牌颜色"
        @click="showColorPicker = true"
        label-align="left"
      />

      <!-- <van-field
        required
        label="业户单位："
        v-model="vehicle.BusinessUnit"
        placeholder="请输入业户单位"
        label-align="left"
      /> -->

      <van-field
        required
        label="业户单位："
        v-model="vehicle.BusinessUnit"
        placeholder="请输入业户单位"
        @click="showBusinessUnitPicker = true"
        label-align="left"
      />

      <van-field
        label="结算单位："
        v-model="vehicle.SettlementCompFullName"
        placeholder="请输入结算单位"
        @click="showSettlementCompPicker = true"
        label-align="left"
      />

      <van-field
        required
        label="核定座位数："
        v-model="vehicle.ApprovedSeatCount"
        placeholder="请输入核定座位数"
        label-align="left"
        type="number"
      />

      <van-field
        required
        label="载客座位数："
        v-model="vehicle.PassengerSeatCount"
        placeholder="请输入载客座位数"
        label-align="left"
        type="number"
      />

      <!-- <van-field
        required
        label="GPS类型："
        v-model="vehicle.GPSTypeName"
        placeholder="请输入GPS类型"
        @click="showGPSTypePicker = true"
        label-align="left"
      /> -->

      <!-- <van-field
        label="行驶证注册日期："
        v-model="vehicle.DrivingLicenseRegistrationDate"
        placeholder="请输入行驶证注册日期"
        @click="showDrivingLicenseRegistrationDatePicker = true"
        label-align="left"
      /> -->

      <van-field
        required
        label="道路运输证有效期："
        v-model="vehicle.TransportCertificateValidityPeriod"
        placeholder="请输入道路运输证有效期"
        @click="showTransportCertificateValidityPeriodPicker = true"
        label-align="left"
      />

      <van-field required label="车辆道路运输证：">
        <template slot="input">
          <van-uploader
            accept="image/*"
            v-model="fileListA"
            :after-read="onTransportCertificateImgPathAfterReadImg"
            :before-delete="onTransportCertificateImgPathBeforeDelete"
            :max-count="1"
            upload-text="点击上传"
            deletable
          />
        </template>
      </van-field>

      <!-- <template slot="input">
          <van-uploader
            :accept="''"
            accept="image/*" 
            capture="camera"
            v-model="fileListA"
            :before-read="onTransportCertificateImgPathBeforeReadImg"
            :after-read="onTransportCertificateImgPathAfterReadImg"
            :before-delete="onTransportCertificateImgPathBeforeDelete"
            :max-count="1"
            upload-text="点击上传"
            deletable
          />
        </template> -->

      <!-- <van-field
        label="年检有效期："
        v-model="vehicle.AnnualInspectionValidityPeriod"
        placeholder="请输入年检有效期"
        @click="showAnnualInspectionValidityPeriodPicker = true"
        label-align="left"
      />

      <van-field label="车辆行驶证正/反面：">
        <template slot="input">
          <van-uploader
            v-model="fileListB"
            :after-read="onDrivingLicenseFrontOrBackImgPathAfterReadImg"
            :before-delete="onDrivingLicenseFrontOrBackImgPathBeforeDelete"
            :max-count="1"
            upload-text="点击上传"
            deletable
          />
        </template>
      </van-field>

      <van-field
        label="交强险有效期："
        v-model="vehicle.TrafficInsuranceValidityPeriod"
        placeholder="请输入交强险有效期"
        @click="showTrafficInsuranceValidityPeriodPicker = true"
        label-align="left"
      />

      <van-field label="车辆交强险图片：">
        <template slot="input">
          <van-uploader
            v-model="fileListC"
            :after-read="onTrafficInsuranceImgPathAfterReadImg"
            :before-delete="onTrafficInsuranceImgPathBeforeDelete"
            :max-count="1"
            upload-text="点击上传"
            deletable
          />
        </template>
      </van-field>

      <van-field
        label="承运险有效期："
        v-model="vehicle.CarrierInsuranceValidityPeriod"
        placeholder="请输入承运险有效期"
        @click="showCarrierInsuranceValidityPeriodPicker = true"
        label-align="left"
      />

      <van-field label="车辆承运险图片：">
        <template slot="input">
          <van-uploader
            v-model="fileListD"
            :after-read="onCarrierInsuranceImgPathAfterReadImg"
            :before-delete="onCarrierInsuranceImgPathBeforeDelete"
            :max-count="1"
            upload-text="点击上传"
            deletable
          />
        </template>
      </van-field>

      <van-field
        label="商业险有效期："
        v-model="vehicle.CommercialInsuranceValidityPeriod"
        placeholder="请输入商业险有效期"
        @click="showCommercialInsuranceValidityPeriodPicker = true"
        label-align="left"
      />

      <van-field label="车辆商业险图片：">
        <template slot="input">
          <van-uploader
            v-model="fileListE"
            :after-read="onCommercialInsuranceImgPathAfterReadImg"
            :before-delete="onCommercialInsuranceImgPathBeforeDelete"
            :max-count="1"
            upload-text="点击上传"
            deletable
          />
        </template>
      </van-field> -->

      <van-field
        label="车身特征："
        v-model="vehicle.BodySign"
        placeholder="可填写车身颜色如：黄色大巴，方便旅客识别"
        label-align="left"
      />

      <!-- <van-field
        label="车队："
        v-model="vehicle.VehicleTeam"
        placeholder="请输入车队"
        label-align="left"
      /> -->

      <!-- <van-field
        label="发动机号："
        v-model="vehicle.EngineNumber"
        placeholder="请输入发动机号"
        label-align="left"
      />

      <van-field
        label="车架号："
        v-model="vehicle.FrameNumber"
        placeholder="请输入车架号"
        label-align="left"
      /> -->

      <van-field
        label="备注："
        v-model="vehicle.Remark"
        placeholder="请输入备注"
        label-align="left"
      />
    </van-cell-group>

    <!-- 运营业务类型选择 -->
    <!-- <van-popup
      v-model="showOperateBusinessTypePicker"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-checkbox-group v-model="operateBusinessTypeGIDList">
        <van-checkbox
          :name="item.GID"
          shape="square"
          v-for="(item, index) in operateBusinessTypeList"
          :key="index"
          >{{ item.CodeName }}</van-checkbox
        >
      </van-checkbox-group>
      <van-button
        class="w100"
        type="default"
        block
        color="#33ccff"
        size="small"
        @click="onSelectOperateBusinessType"
        >确认</van-button
      >
    </van-popup> -->

    <!-- 车牌颜色选择 -->
    <van-popup v-model="showColorPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="coreColor"
        @cancel="showColorPicker = false"
        @confirm="onPickerColor"
      />
    </van-popup>

    <!-- 业务单位选择 -->
    <van-popup v-model="showBusinessUnitPicker" position="bottom">
      <van-search
        v-model="searchBusinessUnitKeyword"
        show-action
        placeholder="请输入搜索关键词"
        @search="onFilteredBusinessUnitList"
      >
        <template #action>
          <div @click="onFilteredBusinessUnitList">搜索</div>
        </template>
      </van-search>

      <!-- <van-field v-model="searchBusinessUnitKeyword" placeholder="搜索选项" />
      <van-button type="default" block @click="onFilteredBusinessUnitList"
        >查询</van-button
      > -->

      <van-picker
        show-toolbar
        :columns="filteredBusinessUnitList"
        @cancel="showBusinessUnitPicker = false"
        @confirm="onPickerBusinessUnit"
      />
    </van-popup>

    <!-- 结算单位选择 -->
    <van-popup v-model="showSettlementCompPicker" position="bottom">
      <van-search
        v-model="searchSettlementCompKeyword"
        show-action
        placeholder="请输入搜索关键词"
        @search="onFilteredSettlementCompList"
      >
        <template #action>
          <div @click="onFilteredSettlementCompList">搜索</div>
        </template>
      </van-search>
      <!-- <van-field v-model="searchSettlementCompKeyword" placeholder="搜索选项" />
      <van-button type="default" block @click="onFilteredSettlementCompList"
        >查询</van-button
      > -->
      <van-picker
        show-toolbar
        :columns="filteredSettlementCompList"
        @cancel="showSettlementCompPicker = false"
        @confirm="onPickerSettlementComp"
      />
    </van-popup>

    <!-- GPS类型选择 -->
    <!-- <van-popup v-model="showGPSTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="gpsTypeList"
        @cancel="showGPSTypePicker = false"
        @confirm="onPickerGPSType"
      />
    </van-popup> -->

    <!-- 行驶证注册日期选择 -->
    <van-popup
      v-model="showDrivingLicenseRegistrationDatePicker"
      position="bottom"
    >
      <!-- <van-calendar
        type="single"
        :min-date="new Date(2000, 0, 1)"
        :max-date="new Date(2050, 11, 31)"
        v-model="showDrivingLicenseRegistrationDatePicker"
        @confirm="onPickerDrivingLicenseRegistrationDate"
      /> -->

      <van-datetime-picker
        v-model="currentDate"
        @cancel="showDrivingLicenseRegistrationDatePicker = false"
        @confirm="onPickerDrivingLicenseRegistrationDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>

    <!-- 道路运输证有效期选择 -->
    <van-popup
      v-model="showTransportCertificateValidityPeriodPicker"
      position="bottom"
    >
      <!-- <van-calendar
        type="single"
        :min-date="new Date(2000, 0, 1)"
        :max-date="new Date(2050, 11, 31)"
        v-model="showTransportCertificateValidityPeriodPicker"
        @confirm="onTransportCertificateValidityPeriod"
      /> -->
      <van-datetime-picker
        v-model="currentDate"
        @cancel="showTransportCertificateValidityPeriodPicker = false"
        @confirm="onTransportCertificateValidityPeriod"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>

    <!-- 年检有效期选择 -->
    <van-popup
      v-model="showAnnualInspectionValidityPeriodPicker"
      position="bottom"
    >
      <!-- <van-calendar
        type="single"
        :min-date="new Date(2000, 0, 1)"
        :max-date="new Date(2050, 11, 31)"
        v-model="showAnnualInspectionValidityPeriodPicker"
        @confirm="onAnnualInspectionValidityPeriod"
      /> -->

      <van-datetime-picker
        v-model="currentDate"
        @cancel="showAnnualInspectionValidityPeriodPicker = false"
        @confirm="onAnnualInspectionValidityPeriod"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>

    <!-- 交强险有效期选择 -->
    <van-popup
      v-model="showTrafficInsuranceValidityPeriodPicker"
      position="bottom"
    >
      <!-- <van-calendar
        type="single"
        :min-date="new Date(2000, 0, 1)"
        :max-date="new Date(2050, 11, 31)"
        v-model="showTrafficInsuranceValidityPeriodPicker"
        @confirm="onTrafficInsuranceValidityPeriod"
      /> -->
      <van-datetime-picker
        v-model="currentDate"
        @cancel="showTrafficInsuranceValidityPeriodPicker = false"
        @confirm="onTrafficInsuranceValidityPeriod"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>

    <!-- 承运险有效期选择 -->
    <van-popup
      v-model="showCarrierInsuranceValidityPeriodPicker"
      position="bottom"
    >
      <!-- <van-calendar
        type="single"
        :min-date="new Date(2000, 0, 1)"
        :max-date="new Date(2050, 11, 31)"
        v-model="showCarrierInsuranceValidityPeriodPicker"
        @confirm="onCarrierInsuranceValidityPeriod"
      /> -->
      <van-datetime-picker
        v-model="currentDate"
        @cancel="showCarrierInsuranceValidityPeriodPicker = false"
        @confirm="onCarrierInsuranceValidityPeriod"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>

    <!-- 商业险有效期选择 -->
    <van-popup
      v-model="showCommercialInsuranceValidityPeriodPicker"
      position="bottom"
    >
      <!-- <van-calendar
        type="single"
        :min-date="new Date(2000, 0, 1)"
        :max-date="new Date(2050, 11, 31)"
        v-model="showCommercialInsuranceValidityPeriodPicker"
        @confirm="onCommercialInsuranceValidityPeriod"
      /> -->

      <van-datetime-picker
        v-model="currentDate"
        @cancel="showCommercialInsuranceValidityPeriodPicker = false"
        @confirm="onCommercialInsuranceValidityPeriod"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>

    <!-- 确认按钮 -->
    <div class="footBtn">
      <van-row>
        <van-col span="12">
          <van-button type="default" block @click="doVehicleSave"
            >保存</van-button
          >
        </van-col>
        <van-col span="12">
          <van-button type="default" block @click="goBack">取消</van-button>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "车辆信息",
      isGetConwin: false,
      vehicle: null, //车辆信息
      vehicleGID: this.$route.query.GID, //车辆GID

      coreColor: [], //车牌颜色
      showColorPicker: false, //显示车牌颜色选择

      operateBusinessTypeGIDList: [],
      operateBusinessTypeList: [], //运营业务类型
      showOperateBusinessTypePicker: false, //显示运营业务类型选择

      businessUnitList: [], //业户单位
      filteredBusinessUnitList: [], //搜索后业户单位
      searchBusinessUnitKeyword: "", //搜索业户单位关键词
      showBusinessUnitPicker: false, //显示业户单位选择

      settlementCompList: [], //结算单位
      filteredSettlementCompList: [], //搜索后结算单位
      searchSettlementCompKeyword: "", //搜索结算单位关键词
      showSettlementCompPicker: false, //显示结算单位选择

      gpsTypeList: [], //GPS类型
      showGPSTypePicker: false, //显示GPS类型选择

      showDrivingLicenseRegistrationDatePicker: false, //显示行驶证注册日期
      showTransportCertificateValidityPeriodPicker: false, //显示道路运输证有效期
      showAnnualInspectionValidityPeriodPicker: false, //显示年检有效期
      showTrafficInsuranceValidityPeriodPicker: false, //显示交强险有效期
      showCarrierInsuranceValidityPeriodPicker: false, //显示承运险有效期
      showCommercialInsuranceValidityPeriodPicker: false, //显示商业险有效期

      fileListA: [], //用于图片展示
      fileListB: [],
      fileListC: [],
      fileListD: [],
      fileListE: [],

      //时间选择组件默认值参数
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2050, 11, 31),
      currentDate: new Date(),
    };
  },
  methods: {
    // onTransportCertificateImgPathBeforeReadImg(file) {
    //   // 定义允许上传的文件类型
    //   const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    //   // 检查当前文件类型是否在允许的类型列表中
    //   if (!allowedTypes.includes(file.type)) {
    //     // 若不在允许列表中，给出提示并阻止文件上传
    //     this.$toast("只能上传 JPEG、PNG 或 JPG 格式的图片");
    //     return false;
    //   }
    // if (file.size > 5 * 1024 * 1024) { // 最大5MB
    //     this.$toast('文件大小超过限制');
    //     return false;
    //   }
    //   // 若文件类型符合要求，允许上传
    //   return true;
    // },
    onTransportCertificateImgPathAfterReadImg(file) {
      this.afterReadImg("车辆道路运输证", file);
    },
    onTransportCertificateImgPathBeforeDelete() {
      this.imgDelete(
        this.vehicle.TransportCertificateImgPath,
        "车辆道路运输证"
      );
    },

    // onDrivingLicenseFrontOrBackImgPathAfterReadImg(file) {
    //   this.afterReadImg("车辆行驶证正/反面", file);
    // },
    // onDrivingLicenseFrontOrBackImgPathBeforeDelete() {
    //   this.imgDelete(
    //     this.vehicle.DrivingLicenseFrontOrBackImgPath,
    //     "车辆行驶证正/反面"
    //   );
    // },

    // onTrafficInsuranceImgPathAfterReadImg(file) {
    //   this.afterReadImg("车辆交强险", file);
    // },
    // onTrafficInsuranceImgPathBeforeDelete() {
    //   this.imgDelete(this.vehicle.TrafficInsuranceImgPath, "车辆交强险");
    // },

    // onCarrierInsuranceImgPathAfterReadImg(file) {
    //   this.afterReadImg("车辆承运险", file);
    // },
    // onCarrierInsuranceImgPathBeforeDelete() {
    //   this.imgDelete(this.vehicle.CarrierInsuranceImgPath, "车辆承运险");
    // },

    // onCommercialInsuranceImgPathAfterReadImg(file) {
    //   this.afterReadImg("车辆商业险", file);
    // },
    // onCommercialInsuranceImgPathBeforeDelete() {
    //   this.imgDelete(this.vehicle.CommercialInsuranceImgPath, "车辆商业险");
    // },

    imgDelete(file, type) {
      debugger;
      if (file.length <= 0) {
        return false;
      }
      this.$dialog
        .confirm({
          title: "删除图片",
          message: "确认删除该图片吗?",
        })
        .then(() => {
          if (type == "车辆道路运输证") {
            this.fileListA = [];
            this.vehicle.TransportCertificateImgPath = "";
          }
          // else if (type == "车辆行驶证正/反面") {
          //   this.fileListB = [];
          //   this.vehicle.DrivingLicenseFrontOrBackImgPath = "";
          // } else if (type == "车辆交强险") {
          //   this.fileListC = [];
          //   this.vehicle.TrafficInsuranceImgPath = "";
          // } else if (type == "车辆承运险") {
          //   this.fileListD = [];
          //   this.vehicle.CarrierInsuranceImgPath = "";
          // } else if (type == "车辆商业险") {
          //   this.fileListE = [];
          //   this.vehicle.CommercialInsuranceImgPath = "";
          // }
          //this.showTicketInfo = false;
          this.$toast("删除成功");
          //this.showTicketInfo = true;
        })
        .catch(() => {
          return false;
        });
    },
    //图片压缩
    afterReadImg(type, file) {
      if (!file) {
        return;
      }
      // 创建Canvas对象(画布)
      let canvas = document.createElement("canvas");
      // 获取对应的CanvasRenderingContext2D对象(画笔)
      let context = canvas.getContext("2d");
      // 创建新的图片对象
      let img = new Image();
      // 指定图片的DataURL(图片的base64编码数据)
      img.src = file.content;
      // 监听浏览器加载图片完成，然后进行进行绘制
      img.onload = () => {
        // 指定canvas画布大小，该大小为最后生成图片的大小
        canvas.width = 800;
        canvas.height = 600;
        /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
        如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/
        context.drawImage(img, 0, 0, 800, 600);
        // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
        file.content = canvas.toDataURL(file.file.type, 0.92);
        let base64Content = file.content;

        if (type == "车辆道路运输证") {
          this.vehicle.TransportCertificateImgPath = base64Content;
        }
        // else if (type == "车辆行驶证正/反面") {
        //   this.vehicle.DrivingLicenseFrontOrBackImgPath = base64Content;
        // } else if (type == "车辆交强险") {
        //   this.vehicle.TrafficInsuranceImgPath = base64Content;
        // } else if (type == "车辆承运险") {
        //   this.vehicle.CarrierInsuranceImgPath = base64Content;
        // } else if (type == "车辆商业险") {
        //   this.vehicle.CommercialInsuranceImgPath = base64Content;
        // }

        //this.showTicketInfo = false;
        this.$toast("上传成功");
        //this.showTicketInfo = true;
      };
    },

    // 确认运营业务类型函数
    // onSelectOperateBusinessType() {
    //   this.vehicle.OperateBusinessTypeNameList = this.operateBusinessTypeList
    //     .filter((v) => this.operateBusinessTypeGIDList.some((g) => g == v.GID))
    //     .map((v) => v.CodeName)
    //     .toString();

    //   this.vehicle.OperateBusinessTypeGIDList =
    //     this.operateBusinessTypeGIDList.toString();
    //   this.showOperateBusinessTypePicker = false;
    // },
    // 业务单位筛选选项
    onFilteredBusinessUnitList() {
      if (!this.searchBusinessUnitKeyword) {
        this.filteredBusinessUnitList = [];
        this.$toast("未输入需要查询的关键字");
        return;
      }

      let params = {
        CompTypeCode: "Transport",
        query: this.searchBusinessUnitKeyword,
      };
      this.$http
        .post(this.$api.getCompInfo, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.filteredBusinessUnitList = [];
            res.data.forEach((item) => {
              this.filteredBusinessUnitList.push({
                text: item.CompFullName,
                id: item.GID,
              });
            });
          }
        });

      // if (this.searchBusinessUnitKeyword === "") {
      //   this.filteredBusinessUnitList = this.businessUnitList;
      // } else {
      //   this.filteredBusinessUnitList = this.businessUnitList.filter((option) =>
      //     option.text.includes(this.searchBusinessUnitKeyword)
      //   );
      // }
    },
    // 结算单位筛选选项
    onFilteredSettlementCompList() {
      if (!this.searchSettlementCompKeyword) {
        this.filteredSettlementCompList = [];
        this.$toast("未输入需要查询的关键字");
        return;
      }

      let params = {
        CompTypeCode: "Operate,Transport",
        query: this.searchSettlementCompKeyword,
      };
      this.$http
        .post(this.$api.getCompInfo, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.filteredSettlementCompList = [];
            res.data.forEach((item) => {
              this.filteredSettlementCompList.push({
                text: item.CompFullName,
                id: item.GID,
              });
            });
          }
        });

      // if (this.searchSettlementCompKeyword === "") {
      //   this.filteredSettlementCompList = this.settlementCompList;
      // } else {
      //   this.filteredSettlementCompList = this.settlementCompList.filter(
      //     (option) => option.text.includes(this.searchSettlementCompKeyword)
      //   );
      // }
    },
    //车辆信息保存
    doVehicleSave() {
      // if (!this.isGetConwin) {
      //   this.$toast.fail("请先获取车辆资质信息");
      //   return;
      // }
      //校验车辆信息
      // if (!this.vehicle.OperateBusinessTypeNameList) {
      //   this.$toast.fail("请输入运营业务类型");
      //   return;
      // }
      //oys 2025-03-06 9:21 运营业务类型默认 "定制客运"
      this.vehicle.OperateBusinessTypeGIDList =
        "EA5BF9BD-23C2-4E80-872F-D86F2EC12709";
      //GPS类型默认 "车盈网"
      this.vehicle.GpsInterfaceTypeCodeGID =
        "2ACCF865-D262-4D99-86F3-DC4D9E21084D";

      if (!this.$utils.isCarNo(this.vehicle.VehicleNo)) {
        this.$toast.fail("请输入正确的车牌号码");
        return;
      }
      if (!this.vehicle.CodeName) {
        this.$toast.fail("请输入车牌颜色");
        return;
      }
      if (!this.vehicle.BusinessUnit) {
        this.$toast.fail("请输入业户单位");
        return;
      }
      if (!this.vehicle.ApprovedSeatCount) {
        this.$toast.fail("请输入核定座位数");
        return;
      }
      if (!this.vehicle.PassengerSeatCount) {
        this.$toast.fail("请输入载客座位数");
        return;
      }
      if (
        parseInt(this.vehicle.PassengerSeatCount) >=
        parseInt(this.vehicle.ApprovedSeatCount)
      ) {
        this.$toast.fail("载客座位数不能大于等于核定座位数");
        return;
      }
      // if (!this.vehicle.GPSTypeName) {
      //   this.$toast.fail("请输入GPS类型");
      //   return;
      // }
      if (!this.vehicle.TransportCertificateValidityPeriod) {
        this.$toast.fail("请输入道路运输证有效期");
        return;
      }
      if (!this.vehicle.TransportCertificateImgPath) {
        this.$toast.fail("请输入车辆道路运输证");
        return;
      }

      //#region 日期处理
      // if (
      //   this.vehicle.DrivingLicenseRegistrationDate == "1900-01-01" ||
      //   this.vehicle.DrivingLicenseRegistrationDate == ""
      // ) {
      //   this.vehicle.DrivingLicenseRegistrationDate = null;
      // }
      if (
        this.vehicle.TransportCertificateValidityPeriod == "1900-01-01" ||
        this.vehicle.TransportCertificateValidityPeriod == ""
      ) {
        this.vehicle.TransportCertificateValidityPeriod = null;
      }
      // if (
      //   this.vehicle.AnnualInspectionValidityPeriod == "1900-01-01" ||
      //   this.vehicle.AnnualInspectionValidityPeriod == ""
      // ) {
      //   this.vehicle.AnnualInspectionValidityPeriod = null;
      // }
      // if (
      //   this.vehicle.TrafficInsuranceValidityPeriod == "1900-01-01" ||
      //   this.vehicle.TrafficInsuranceValidityPeriod == ""
      // ) {
      //   this.vehicle.TrafficInsuranceValidityPeriod = null;
      // }
      // if (
      //   this.vehicle.CarrierInsuranceValidityPeriod == "1900-01-01" ||
      //   this.vehicle.CarrierInsuranceValidityPeriod == ""
      // ) {
      //   this.vehicle.CarrierInsuranceValidityPeriod = null;
      // }
      // if (
      //   this.vehicle.CommercialInsuranceValidityPeriod == "1900-01-01" ||
      //   this.vehicle.CommercialInsuranceValidityPeriod == ""
      // ) {
      //   this.vehicle.CommercialInsuranceValidityPeriod = null;
      // }
      //#endregion

      //保存
      let params = {
        _JsonText: this.vehicle,
      };
      params._JsonText.ModifyGID = JSON.parse(
        window.localStorage.getItem("adminInfo")
      ).GID;
      params._JsonText.ModifyCode = JSON.parse(
        window.localStorage.getItem("adminInfo")
      ).UserCode;
      params._JsonText.ModifyName = JSON.parse(
        window.localStorage.getItem("adminInfo")
      ).UserName;
      params._JsonText = JSON.stringify(params._JsonText);
      this.$http
        .post(this.$api.onSaveVehicle, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            //保存成功
            this.$toast.fail("保存成功");
            this.$router.push({
              name: "VehicleHome",
              params: {
                vehicleNo: this.vehicle.VehicleNo,
              },
            });
          }
        });
    },
    //返回上一页
    goBack() {
      history.back();
    },
    //获取车辆省厅接口信息
    getConwinVehicleInfo() {
      if (!this.vehicle.VehicleNo) {
        this.$toast.fail("请输入车牌号码");
        return;
      }
      this.isGetConwin = true;
      let params = {
        VehicleNo: this.vehicle.VehicleNo,
        VehicleNoColor: this.vehicle.CodeName,
        QueryTypeList: "Qualifications,VehicleLineSign",
      };
      this.$http
        .post(this.$api.onConwinVehicleQuery, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            if (res.data.ConwinAPIIsError === "1") {
              //接口异常
              this.$toast.fail("省厅接口异常,获取信息失败");
              return;
            }
            //资质接口返回失败
            if (!res.data.VehicleData.success) {
              this.$toast.fail(res.data.VehicleData.msg);
              this.vehicle.VehicleYunZhengInfo = null;
              this.vehicle.CompInfo = null;
              this.vehicle.BusinessUnit = null;
              this.vehicle.ApprovedSeatCount = null;
              this.vehicle.PassengerSeatCount = null;
            } else {
              this.$toast("获取车辆资质信息成功");
              this.vehicle.CompInfo = res.data.CompanyData.data;
              this.vehicle.VehicleYunZhengInfo = {
                vehicleData: res.data.VehicleData.data,
                vehicleLineSignData: res.data.VehicleLineSignData.data,
                vehicleTransportLineData:
                  res.data.VehicleTransportLineData.data,
                compData: res.data.CompanyData.data,
              };
              this.vehicle.BusinessUnit = res.data.VehicleData.data.ownername;
              if (res.data.VehicleData.data.seat) {
                this.vehicle.ApprovedSeatCount = res.data.VehicleData.data.seat;
                this.vehicle.PassengerSeatCount =
                  res.data.VehicleData.data.seat - 1;
              }
            }
          }
        });
    },
    //车牌颜色确认选择
    onPickerColor(value) {
      this.vehicle.CodeName = value.text;
      this.vehicle.VehicleNoColorGID = value.id;
      this.showColorPicker = false;
    },
    //业务单位确认选择
    onPickerBusinessUnit(value) {
      this.vehicle.BusinessUnit = value.text;
      this.showBusinessUnitPicker = false;
    },
    //结算单位确认选择
    onPickerSettlementComp(value) {
      this.vehicle.SettlementCompFullName = value.text;
      this.vehicle.SettlementCompGID = value.id;
      this.showSettlementCompPicker = false;
    },
    //GPS类型确认选择
    onPickerGPSType(value) {
      this.vehicle.GPSTypeName = value.text;
      this.vehicle.GpsInterfaceTypeCodeGID = value.id;
      this.showGPSTypePicker = false;
    },
    //行驶证注册日期确认选择
    onPickerDrivingLicenseRegistrationDate(date) {
      if (date) {
        this.vehicle.DrivingLicenseRegistrationDate = this.formatDate(date);
      }
      this.showDrivingLicenseRegistrationDatePicker = false;
    },
    //道路运输证有效期确认选择
    onTransportCertificateValidityPeriod(date) {
      if (date) {
        this.vehicle.TransportCertificateValidityPeriod = this.formatDate(date);
      }
      this.showTransportCertificateValidityPeriodPicker = false;
    },
    //年检有效期确认选择
    onAnnualInspectionValidityPeriod(date) {
      if (date) {
        this.vehicle.AnnualInspectionValidityPeriod = this.formatDate(date);
      }
      this.showAnnualInspectionValidityPeriodPicker = false;
    },
    //交强险有效期确认选择
    onTrafficInsuranceValidityPeriod(date) {
      if (date) {
        this.vehicle.TrafficInsuranceValidityPeriod = this.formatDate(date);
      }
      this.showTrafficInsuranceValidityPeriodPicker = false;
    },
    //承运险有效期确认选择
    onCarrierInsuranceValidityPeriod(date) {
      if (date) {
        this.vehicle.CarrierInsuranceValidityPeriod = this.formatDate(date);
      }
      this.showCarrierInsuranceValidityPeriodPicker = false;
    },
    //商业险有效期确认选择
    onCommercialInsuranceValidityPeriod(date) {
      if (date) {
        this.vehicle.CommercialInsuranceValidityPeriod = this.formatDate(date);
      }
      this.showCommercialInsuranceValidityPeriodPicker = false;
    },
    //日期转换格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}` == "1900-01-01 00:00:00"
        ? ""
        : `${year}-${month}-${day}`;
    },
    //获取车辆信息
    getVehicleInfo() {
      let params = {
        GID: this.vehicleGID,
      };
      this.$http
        .post(this.$api.onCompVehicleQuery, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            res.data.forEach((item) => {
              item.DrivingLicenseRegistrationDate =
                item.DrivingLicenseRegistrationDate &&
                this.$moment(item.DrivingLicenseRegistrationDate).format(
                  "YYYY-MM-DD"
                );

              item.AnnualInspectionValidityPeriod =
                item.AnnualInspectionValidityPeriod &&
                this.$moment(item.AnnualInspectionValidityPeriod).format(
                  "YYYY-MM-DD"
                );

              item.TransportCertificateValidityPeriod =
                item.TransportCertificateValidityPeriod &&
                this.$moment(item.TransportCertificateValidityPeriod).format(
                  "YYYY-MM-DD"
                );

              item.TrafficInsuranceValidityPeriod =
                item.TrafficInsuranceValidityPeriod &&
                this.$moment(item.TrafficInsuranceValidityPeriod).format(
                  "YYYY-MM-DD"
                );

              item.CommercialInsuranceValidityPeriod =
                item.CommercialInsuranceValidityPeriod &&
                this.$moment(item.CommercialInsuranceValidityPeriod).format(
                  "YYYY-MM-DD"
                );

              item.CarrierInsuranceValidityPeriod =
                item.CarrierInsuranceValidityPeriod &&
                this.$moment(item.CarrierInsuranceValidityPeriod).format(
                  "YYYY-MM-DD"
                );
            });

            this.vehicle = res.data[0];
          }
          //初始化默认值，避免后台取值报错
          this.vehicle.TransportCertificateImgPath = "";
          this.vehicle.DrivingLicenseFrontOrBackImgPath = "";
          this.vehicle.TrafficInsuranceImgPath = "";
          this.vehicle.CarrierInsuranceImgPath = "";
          this.vehicle.CommercialInsuranceImgPath = "";

          if (this.vehicle) {
            let params2 = {
              ObjectCode: "Vehicle",
              ObjectGID: this.vehicle.VehicleGID,
              start: 0,
              limit: 10,
            };

            this.$http
              .post(
                this.$api.onLineClassDayAttachmentQuery,
                this.$qs.stringify(params2)
              )
              .then((res) => {
                if (res.success) {
                  res.data.forEach((item) => {
                    if (item.FileName == "车辆道路运输证") {
                      this.fileListA = [{ url: item.UrlAbsolutelPath }];
                      this.vehicle.TransportCertificateImgPath =
                        item.UrlAbsolutelPath;
                    }
                    // else if (item.FileName == "车辆行驶证正/反面") {
                    //   this.fileListB = [{ url: item.UrlAbsolutelPath }];
                    //   this.vehicle.DrivingLicenseFrontOrBackImgPath =
                    //     item.UrlAbsolutelPath;
                    // } else if (item.FileName == "车辆交强险") {
                    //   this.fileListC = [{ url: item.UrlAbsolutelPath }];
                    //   this.vehicle.TrafficInsuranceImgPath =
                    //     item.UrlAbsolutelPath;
                    // } else if (item.FileName == "车辆承运险") {
                    //   this.fileListD = [{ url: item.UrlAbsolutelPath }];
                    //   this.vehicle.CarrierInsuranceImgPath =
                    //     item.UrlAbsolutelPath;
                    // } else if (item.FileName == "车辆商业险") {
                    //   this.fileListE = [{ url: item.UrlAbsolutelPath }];
                    //   this.vehicle.CommercialInsuranceImgPath =
                    //     item.UrlAbsolutelPath;
                    // }
                  });
                }
              });
          }
        });
    },
    //获取系统车票颜色
    getCoreColor() {
      let params = {
        GroupCode: "VehicleNoColor",
        IsEnable: 1,
        sort: "OrderByNo",
        dir: "ASC",
      };
      this.$http
        .post(this.$api.onGetCoreColor, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.coreColor = [];
            // let color = "黄色";
            // let colorid = null;
            res.data.forEach((item) => {
              this.coreColor.push({
                text: item.CodeName,
                id: item.GID,
              });
              // if (item.CodeName == color) {
              //   colorid = item.GID;
              // }
            });
            if (this.vehicleGID) {
              this.getVehicleInfo();
            } else {
              this.vehicle = {
                VehicleNo: null,
                CompGID: JSON.parse(window.localStorage.getItem("adminInfo"))
                  .CompGID,
                CodeName: null,
                VehicleNoColorGID: null,
                BusinessUnit: null,
                ApprovedSeatCount: null,
                PassengerSeatCount: null,
                BodySign: null,
                EngineNumber: null,
                FrameNumber: null,
                Remark: null,
                //初始化默认值，避免后台取值报错
                TransportCertificateImgPath: "",
                DrivingLicenseFrontOrBackImgPath: "",
                TrafficInsuranceImgPath: "",
                CarrierInsuranceImgPath: "",
                CommercialInsuranceImgPath: "",
              };
            }
          }
        });
    },
    //获取运营业务类型信息
    // getOperateBusinessTypeList() {
    //   let params = {
    //     GroupCode: "OperateBusinessType",
    //   };
    //   this.$http
    //     .post(this.$api.onGetCoreColor, this.$qs.stringify(params))
    //     .then((res) => {
    //       if (res.success) {
    //         this.operateBusinessTypeList = res.data;
    //       }
    //     });
    // },
    //获取业户单位
    getBusinessUnitList() {
      let params = {
        CompTypeCode: "Transport",
      };
      this.$http
        .post(this.$api.getCompInfo, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.businessUnitList = [];
            res.data.forEach((item) => {
              this.businessUnitList.push({
                text: item.CompFullName,
                id: item.GID,
              });
            });
          }
        });
    },
    //获取结算单位
    getSettlementCompList() {
      let params = {
        CompTypeCode: "Operate,Transport",
      };
      this.$http
        .post(this.$api.getCompInfo, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.settlementCompList = [];
            res.data.forEach((item) => {
              this.settlementCompList.push({
                text: item.CompFullName,
                id: item.GID,
              });
            });
          }
        });
    },
    //获取GPS类型
    // getGPSTypeList() {
    //   let params = {
    //     GroupCode: "VehicleGpsInterfaceType",
    //   };
    //   this.$http
    //     .post(this.$api.onGetCoreColor, this.$qs.stringify(params))
    //     .then((res) => {
    //       if (res.success) {
    //         this.gpsTypeList = [];
    //         res.data.forEach((item) => {
    //           this.gpsTypeList.push({
    //             text: item.CodeName,
    //             id: item.GID,
    //           });
    //         });
    //       }
    //     });
    // },
  },
  mounted() {
    //this.getOperateBusinessTypeList();
    //this.getBusinessUnitList();
    //this.getSettlementCompList();
    //this.getGPSTypeList();
  },
  created() {
    this.vehicleGID = this.$route.query.GID;
    this.getCoreColor();
  },
};
</script>

<style scoped lang="less">
.van-popup {
  .van-checkbox {
    margin: 0.267rem;
  }
}

// .footBtn {
//   position: fixed;
//   width: 100%;
//   bottom: 0rem;
// }
.page {
  text-align: left;
}
</style>
